import React, { useState } from 'react';
import { motion } from 'framer-motion';

// styles
import styles from "./index.module.scss";
import classNames from "classnames/bind";
const cn = classNames.bind(styles);

const Header = () => {
  // const url = process.env.REACT_APP_BASE_URL || '';
  const [isOpen, setIsOpen] = useState(false);

  const toggleMenu = () => setIsOpen(!isOpen);

  const menuVariants = {
    open: {
      clipPath: "inset(0% 0% 0% 0% round 10px)",
      transition: {
        type: "spring",
        stiffness: 400,
        damping: 40,
        when: "beforeChildren",
        staggerChildren: 0.1,
      },
    },
    closed: {
      clipPath: "inset(0% 0% 0% 100% round 10px)",
      transition: {
        type: "spring",
        stiffness: 400,
        damping: 40,
        when: "afterChildren",
        staggerChildren: 0.05,
        staggerDirection: -1,
      },
    },
  };

  const menuItemVariants = {
    open: {
      opacity: 1,
      x: 0,
      transition: {
        type: "spring",
        stiffness: 300,
        damping: 24,
      },
    },
    closed: {
      opacity: 0,
      x: 50,
      transition: {
        type: "spring",
        stiffness: 300,
        damping: 24,
      },
    },
  };

  return (
    <header className={cn("wrapper")}>
      <div className={cn("container")}>
        <div className={cn("logo")}>
          <a href="/">
            <img src="/logo_green.png" alt="studio bevilacqua logo" decoding="async" />
          </a>
        </div>
        <div className={cn("desktop-links")}>
          <a href="/"><span>Home</span></a>
          <a href="/valori"><span>I nostri valori</span></a>
          <a href="/#servizi"><span>Aree di attività</span></a>
          <a href="/contatti"><span>Contatti</span></a>
        </div>
        <div className={cn("mobile-menu")}>
          <button onClick={toggleMenu} className={cn("hamburger", { open: isOpen })}>
            <span></span>
            <span></span>
            <span></span>
          </button>
          <motion.div
            className={cn("mobile-links")}
            initial="closed"
            animate={isOpen ? "open" : "closed"}
            variants={menuVariants}
          >
            <motion.a href="/" onClick={toggleMenu} variants={menuItemVariants}>Home</motion.a>
            <motion.a href="/valori" onClick={toggleMenu} variants={menuItemVariants}>I nostri valori</motion.a>
            <motion.a href="/#servizi" onClick={toggleMenu} variants={menuItemVariants}>Aree di attività</motion.a>
            <motion.a href="/contatti" onClick={toggleMenu} variants={menuItemVariants}>Contatti</motion.a>
          </motion.div>
        </div>
      </div>
    </header>
  );
};

export default Header;